import styled from '@emotion/styled';

export const TagsContainer = styled.div`
    display:inline-flex;
    flex-wrap: wrap;
    width: 100%;
    gap:10px;
    padding-bottom: 10px;
    position: relative;
    min-height: 36px;
`; 


export const BackgroundOvarlay = styled.div`
    position: absolute;
    bottom:0;
    left:0;
    width:100%;
    height:100px;
    background: rgb(255,255,255);
    background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 60%);
    z-index: 0;
    pointer-events: none;
`; 

export const TagButton = styled.button<{bgColor?:string, c?:boolean}>`
    background: ${props => props.bgColor?"#" + props.bgColor:"#959595"};
    color: ${props => props.c?"black":"#fff"};
    font-size: 16px;
    padding:4px 12px 3px 12px;
    border-radius: 5px;
    transition: transform 0.1s ease-in-out;
    z-index: 2;
    text-wrap:nowrap;

    :hover{
        transform: scale(1.05);
    }
`; 

export const SpecialTags = styled.div`
    width:250px;
    display:flex;
    flex-direction: column;
    gap:2px;

    span{
        display:flex;
        align-items: center;
        gap:6px;
        color:#FA505E;
        font-size: 16px;
        div{
            border:2px solid #FA505E;
            height:22px;
            width:22px;
            border-radius: 5px;
            transition: all 0.1s ease-in-out;
        }

        :hover{
            cursor: pointer;

            div{
                background:#FA505E;
            }
        }
    }

    
`; 